/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.96"
        height="11.12"
        viewBox="0 0 18.96 11.12"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M18.95 0h-19v11.12h19Zm-18 1H3.4A3.06 3.06 0 0 1 .95 3.59Zm0 9.12V7.56a3 3 0 0 1 2.45 2.56Zm17 0h-2.44a3 3 0 0 1 2.44-2.56Zm0-3.57a4 4 0 0 0-3.45 3.57h-10a4 4 0 0 0-3.45-3.57V4.6A4.06 4.06 0 0 0 4.51 1h10a4 4 0 0 0 3.45 3.6Zm0-3A3.06 3.06 0 0 1 15.51.96h2.44Zm-7.94 1.61v-.9a1.31 1.31 0 0 1 .56.29l.1.1.73-.69-.1-.11a2.53 2.53 0 0 0-1.29-.63v-1h-1v.93a1.84 1.84 0 0 0-1.13.49 1.26 1.26 0 0 0-.35.94c0 .83.76 1.15 1.48 1.33v1.07a1.91 1.91 0 0 1-1-.46l-.11-.1-.67.74.11.1a3 3 0 0 0 1.63.72v.87h1v-.89a2 2 0 0 0 1.07-.52 1.26 1.26 0 0 0 .35-.94c0-.79-.72-1.12-1.38-1.3Zm-1-.25c-.47-.15-.48-.27-.48-.35a.23.23 0 0 1 .07-.19.76.76 0 0 1 .41-.18Zm1.34 1.88a.81.81 0 0 1-.34.19v-.77c.38.14.41.25.42.38a.23.23 0 0 1-.08.2Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'PaperMoneyIcon';

export default Icon;
